export function getJobOfferRecoveryPath(mode) {
	return mode === 'organization' ? '/dashboard' : '/browse'
}
